// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__15ph2","spinnerWrapper":"Loader_spinnerWrapper__T3CGF","loader":"Loader_loader__6Zw6L","l1":"Loader_l1__kxIRk"};